import type { UserModel } from "models/UserModel";

export function formatDate(
  raw: string | Date | null | undefined,
): string | null {
  if (!raw) return null;
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

/** One line on the membership's state, for settings and the membership page. */
export function membershipSummary(user: UserModel): string {
  if (!user.hasActiveSubscription) return "No active membership";
  const ends = formatDate(user.subscriptionEndsAt);
  if (user.subscriptionScheduledForCancellation) {
    return ends ? `Cancelled. Access until ${ends}` : "Cancelled";
  }
  const renews = formatDate(user.data.subscription?.currentPeriodEnd);
  return renews ? `Active. Renews on ${renews}` : "Active";
}
